module.exports = __webpack_public_path__ + "static/media/3.0d40be7b.JPG";